
/**
 * CARIBE7 MODULES
 */
import Emitter      from '@shared/services/main/events';
import RequestClient from '@shared/services/main/request-client';
import BaseService  from '@shared/services/base/BaseService'
import ENDPOINTS    from '@shared/lib/constants/endpoints';
import EVENT_NAMES  from '@shared/lib/constants/events';
import AUTH_CONFIG  from '@shared/lib/constants/auth-config';
import {LocalStorage} from '@shared/services/main/storage';
import RequestSource from '@shared/services/main/request/tokens';

/**
 * Regsiter Service
 *
 * @class      SessionService (name)
 */
function SessionService(component) {
  this.component            = component;
  this.session_event_group  = EVENT_NAMES.AUTH;
  this.user_endpoint        = ENDPOINTS.USER;
  this.session_watch_timout = null;
}

SessionService.prototype = Object.assign(SessionService.prototype, BaseService.prototype);

/**
 * Triggers the waitch timeout
 */
SessionService.prototype.watchSessionId = function() {
  const mili = AUTH_CONFIG.CHECK_INTERVAL * 1000;
  if (LocalStorage.has('user')) {
    this.session_watch_timout = setInterval(this.onSessionProceed.bind(this), mili);
  }
};

/**
 * Stops watching session timeout.
 */
SessionService.prototype.stopWatchingSession = function() {
  clearInterval(this.session_watch_timout);
};

/**
 * Registers Regsiter events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
SessionService.prototype.registerSessionEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.session_event_group.SESSION_WATCH]   = 'watchSessionId';
  event_callback_map[this.session_event_group.SESSION_PROCEED] = 'onSessionProceed';
  event_callback_map[this.session_event_group.SESSION_SUCCESS] = 'onSessionSuccess';
  event_callback_map[this.session_event_group.SESSION_FAIL]    = 'onSessionFail';
  this.registerEvents(event_callback_map, service);
  Emitter.on(
    EVENT_NAMES.AUTH.LOGOUT_SUCCESS_AFTER + '-session-service',
    this.stopWatchingSession.bind(this)
  );
  return this;
}

/**
 * Removes Regsiter events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
SessionService.prototype.removeSessionEvents = function() {
  this.removeEvents([
    this.session_event_group.SESSION_WATCH,
    this.session_event_group.SESSION_PROCEED,
    this.session_event_group.SESSION_SUCCESS,
    this.session_event_group.SESSION_FAIL
  ]);
  Emitter.off(EVENT_NAMES.AUTH.LOGOUT_SUCCESS_AFTER + '-session-service');
  return this;
}


/**
 * Called when Regsiter proceed.
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
SessionService.prototype.onSessionProceed = function() {
  let token_source = this.renewCancelToken(RequestClient, this.session_event_group.SESSION_PROCEED);
  let request = RequestClient.get(this.user_endpoint, {
    cancelToken: token_source.token,
    withCredentials: true, // Explicitly ensure cookies are sent
  });
  this.bindResultEvents(
    request,
    this.session_event_group.SESSION_SUCCESS,
    this.session_event_group.SESSION_FAIL
  );
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
SessionService.prototype.onSessionSuccess = function(response) {
  // Store platform session_id from getCurrentUser response if available
  if (response && response.data && response.data.session_id) {
    LocalStorage.set('platform_session_id', response.data.session_id);
    console.log('[SessionService] Stored platform_session_id from getCurrentUser response:', response.data.session_id.substring(0, 10) + '...');
  }
  return true;
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
SessionService.prototype.onSessionFail = function(error) {
  const errors = error || {};
  // Check response status (Axios puts status in error.response.status)
  const response = errors.response || {};
  const status = response.status;
  
  // Only logout on 401 (Unauthorized) or 403 (Forbidden) - not on network errors or 500s
  if (status === 401 || status === 403) {
    this.stopWatchingSession();
    Emitter.emit(EVENT_NAMES.AUTH.LOGOUT_SUCCESS, {});
  }
}

export default SessionService;